// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "reindl-booking-system.firebaseapp.com",
  projectId: "reindl-booking-system",
  storageBucket: "reindl-booking-system.appspot.com",
  messagingSenderId: "912434694131",
  appId: "1:912434694131:web:243bdff207f035affd3486",
  measurementId: "G-J9324YMQY5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth()
// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);



